__turbopack_context__.v({
  "accordionContainer": "LinkedAssetsSection-module__uesehG__accordionContainer",
});
